(function () {
  if (window.innerWidth > 768) return;

  const ACTIVE_CLASS = "active";
  const HIDDEN_CLASS = "dashboard-nav-content-hidden";
  const MOBILE_HIDDEN_CLASS = "hidden";
  const SUB_MENU_ID = "db-mobile-menu-sub-nav-item";
  const ARROW_ICON_ID = "db-mobile-menu-setting-icon";
  const SETTINGS_BUTTON_ID = "db-mobile-menu-nav-setting-btn";
  const ACCOUNT_SUB_MENU_ID = "mob-db-nav2-menu-sub-nav-item";
  const ACCOUNT_ARROW_ICON_ID = "mob-db-nav2-menu-setting-icon";
  const ACCOUNT_BUTTON_ID = "mob-db-nav2-menu-nav-setting-btn";
  const MENU_DRAWER_CLASS = "custom-db-mobile-menu-drawer-container";

  const navItems = {
    "db-menu-nav-profile": {
      content: "db-menu-content-profile",
    },
    "db-menu-nav-preferences": {
      content: "db-menu-content-preferences",
    },
    "db-menu-nav-referral": {
      content: "db-menu-content-referral",
    },
    "db-menu-nav-microbiome": {
      content: "db-menu-content-microbiome",
    },
    "db-menu-nav-accountsetting": {
      content: "db-menu-content-accountsetting",
    },
    "db-menu-nav-addresssetting": {
      content: "db-menu-content-addresssetting",
    },
    "db-menu-nav-subscription": {
      content: "db-menu-content-subscription",
    },
    "db-menu-nav-dataprivacy": {
      content: "db-menu-content-dataprivacy",
    },
    "db-menu-nav-notifications": {
      content: "db-menu-content-notification",
    },
  };

  const settingsMenuIdMap = {
    "db-mobile-menu-nav-accountsetting": "db-menu-nav-accountsetting",
    "db-mobile-menu-nav-addresssetting": "db-menu-nav-addresssetting",
    "db-mobile-menu-nav-subscription": "db-menu-nav-subscription",
    "db-mobile-menu-nav-dataprivacy": "db-menu-nav-dataprivacy",
    "db-mobile-menu-nav-notifications": "db-menu-nav-notifications",
  };

  const accountMenuIdMap = {
    "mob-db-nav2-menu-nav-accountsetting": "db-menu-nav-profile",
    "mob-db-nav2-menu-nav-addresssetting": "db-menu-nav-preferences",
    "mob-db-nav2-menu-nav-subscription": "db-menu-nav-referral",
    "mob-db-nav2-menu-nav-dataprivacy": "db-menu-nav-microbiome",
  };

  let isNavigating = false;

  function switchNavItem(event) {
    event.preventDefault();
    event.stopPropagation();

    if (isNavigating) return;
    isNavigating = true;
    setTimeout(() => {
      isNavigating = false;
    }, 100);

    const clickedElementId = event.currentTarget.id;
    const clickedNavId =
      accountMenuIdMap[clickedElementId] || settingsMenuIdMap[clickedElementId] || clickedElementId.replace("db-mobile-menu-nav-", "db-menu-nav-");

    localStorage.setItem("mobileActiveNavItem", clickedElementId);

    const settingsSubMenu = document.getElementById(SUB_MENU_ID);
    const settingsArrowIcon = document.getElementById(ARROW_ICON_ID);
    const accountSubMenu = document.getElementById(ACCOUNT_SUB_MENU_ID);
    const accountArrowIcon = document.getElementById(ACCOUNT_ARROW_ICON_ID);

    settingsSubMenu.classList.add(MOBILE_HIDDEN_CLASS);
    settingsArrowIcon.classList.remove("ds-settings-sub-menu-svg-css-up");
    settingsArrowIcon.classList.add("ds-settings-sub-menu-svg-css-down");
    accountSubMenu.classList.add(MOBILE_HIDDEN_CLASS);
    accountArrowIcon.classList.remove("ds-settings-sub-menu-svg-css-up");
    accountArrowIcon.classList.add("ds-settings-sub-menu-svg-css-down");

    if (Object.values(settingsMenuIdMap).includes(clickedNavId)) {
      settingsSubMenu.classList.remove(MOBILE_HIDDEN_CLASS);
      settingsArrowIcon.classList.remove("ds-settings-sub-menu-svg-css-down");
      settingsArrowIcon.classList.add("ds-settings-sub-menu-svg-css-up");
    } else if (Object.keys(accountMenuIdMap).includes(clickedElementId)) {
      accountSubMenu.classList.remove(MOBILE_HIDDEN_CLASS);
      accountArrowIcon.classList.remove("ds-settings-sub-menu-svg-css-down");
      accountArrowIcon.classList.add("ds-settings-sub-menu-svg-css-up");
    }

    if (window.location.pathname === "/pages/dashboard") {
      Object.keys(settingsMenuIdMap).forEach((mobileNavId) => {
        const navElement = document.getElementById(mobileNavId);
        if (navElement) navElement.classList.remove(ACTIVE_CLASS);
      });
      Object.keys(accountMenuIdMap).forEach((navId) => {
        const navElement = document.getElementById(navId);
        if (navElement) navElement.classList.remove(ACTIVE_CLASS);
      });

      Object.keys(navItems).forEach((navId) => {
        const navElement = document.getElementById(navId);
        if (navElement) navElement.classList.remove(ACTIVE_CLASS);
      });

      Object.keys(navItems).forEach((navId) => {
        const contentElement = document.getElementById(navItems[navId].content);
        if (contentElement) contentElement.classList.add(HIDDEN_CLASS);
      });

      const mobileNavElement = document.getElementById(clickedElementId);
      const targetContentElement = document.getElementById(navItems[clickedNavId].content);
      if (targetContentElement) targetContentElement.classList.remove(HIDDEN_CLASS);
      if (mobileNavElement) mobileNavElement.classList.add(ACTIVE_CLASS);

      window.location.hash = clickedNavId;

      const menuDrawer = document.querySelector("." + MENU_DRAWER_CLASS);
      if (menuDrawer) {
        menuDrawer.removeAttribute("open");
        document.body.style.overflow = "auto";
      }

      const menuToggle = document.querySelector(".header__icon--menu");
      if (menuToggle) {
        menuToggle.setAttribute("aria-expanded", "false");
      }
    } else {
      window.location = "/pages/dashboard#" + clickedNavId;
    }

    window.scrollTo(0, 0);
  }

  function toggleSettingsMenu(event) {
    event.stopPropagation();
    const subMenu = document.getElementById(SUB_MENU_ID);
    const arrowIcon = document.getElementById(ARROW_ICON_ID);
    const isHidden = subMenu.classList.contains(MOBILE_HIDDEN_CLASS);

    subMenu.classList.toggle(MOBILE_HIDDEN_CLASS);
    arrowIcon.classList.toggle("ds-settings-sub-menu-svg-css-down", !isHidden);
    arrowIcon.classList.toggle("ds-settings-sub-menu-svg-css-up", isHidden);
  }

  function toggleAccountMenu(event) {
    event.stopPropagation();
    const subMenu = document.getElementById(ACCOUNT_SUB_MENU_ID);
    const arrowIcon = document.getElementById(ACCOUNT_ARROW_ICON_ID);
    const isHidden = subMenu.classList.contains(MOBILE_HIDDEN_CLASS);

    subMenu.classList.toggle(MOBILE_HIDDEN_CLASS);
    arrowIcon.classList.toggle("ds-settings-sub-menu-svg-css-down", !isHidden);
    arrowIcon.classList.toggle("ds-settings-sub-menu-svg-css-up", isHidden);
  }

  function restoreNavItem() {
    if (window.location.pathname !== "/pages/dashboard") return;

    const hashNavId = window.location.hash?.substring(1);
    const storedNavId = localStorage.getItem("mobileActiveNavItem") || "db-menu-nav-profile";

    const reverseAccountMenuIdMap = Object.fromEntries(Object.entries(accountMenuIdMap).map(([mobileId, desktopId]) => [desktopId, mobileId]));
    const reverseSettingsMenuIdMap = Object.fromEntries(Object.entries(settingsMenuIdMap).map(([mobileId, desktopId]) => [desktopId, mobileId]));

    let activeMobileNavId;
    if (Object.keys(accountMenuIdMap).includes(storedNavId)) {
      activeMobileNavId = storedNavId;
    } else if (Object.keys(settingsMenuIdMap).includes(storedNavId)) {
      activeMobileNavId = storedNavId;
    } else if (navItems[hashNavId] && reverseAccountMenuIdMap[hashNavId]) {
      activeMobileNavId = reverseAccountMenuIdMap[hashNavId];
    } else if (navItems[hashNavId] && reverseSettingsMenuIdMap[hashNavId]) {
      activeMobileNavId = reverseSettingsMenuIdMap[hashNavId];
    } else {
      activeMobileNavId = "db-menu-nav-profile";
    }

    const activeNavId =
      accountMenuIdMap[activeMobileNavId] || settingsMenuIdMap[activeMobileNavId] || activeMobileNavId.replace("db-mobile-menu-nav-", "db-menu-nav-");

    const { content: targetContentId } = navItems[activeNavId];

    Object.keys(settingsMenuIdMap).forEach((mobileNavId) => {
      const navElement = document.getElementById(mobileNavId);
      if (navElement) navElement.classList.remove(ACTIVE_CLASS);
    });
    Object.keys(accountMenuIdMap).forEach((navId) => {
      const navElement = document.getElementById(navId);
      if (navElement) navElement.classList.remove(ACTIVE_CLASS);
    });

    Object.keys(navItems).forEach((navId) => {
      const navElement = document.getElementById(navId);
      if (navElement) navElement.classList.remove(ACTIVE_CLASS);
    });

    Object.keys(navItems).forEach((navId) => {
      const contentElement = document.getElementById(navItems[navId].content);
      if (contentElement) contentElement.classList.add(HIDDEN_CLASS);
    });

    const targetMobileNavElement = document.getElementById(activeMobileNavId);
    const targetContentElement = document.getElementById(targetContentId);
    if (targetContentElement) targetContentElement.classList.remove(HIDDEN_CLASS);
    if (targetMobileNavElement) targetMobileNavElement.classList.add(ACTIVE_CLASS);

    const settingsSubMenu = document.getElementById(SUB_MENU_ID);
    const settingsArrowIcon = document.getElementById(ARROW_ICON_ID);
    const accountSubMenu = document.getElementById(ACCOUNT_SUB_MENU_ID);
    const accountArrowIcon = document.getElementById(ACCOUNT_ARROW_ICON_ID);

    settingsSubMenu.classList.add(MOBILE_HIDDEN_CLASS);
    settingsArrowIcon.classList.remove("ds-settings-sub-menu-svg-css-up");
    settingsArrowIcon.classList.add("ds-settings-sub-menu-svg-css-down");
    accountSubMenu.classList.add(MOBILE_HIDDEN_CLASS);
    accountArrowIcon.classList.remove("ds-settings-sub-menu-svg-css-up");
    accountArrowIcon.classList.add("ds-settings-sub-menu-svg-css-down");

    if (Object.values(settingsMenuIdMap).includes(activeNavId)) {
      settingsSubMenu.classList.remove(MOBILE_HIDDEN_CLASS);
      settingsArrowIcon.classList.remove("ds-settings-sub-menu-svg-css-down");
      settingsArrowIcon.classList.add("ds-settings-sub-menu-svg-css-up");
    } else if (Object.keys(accountMenuIdMap).includes(activeMobileNavId)) {
      accountSubMenu.classList.remove(MOBILE_HIDDEN_CLASS);
      accountArrowIcon.classList.remove("ds-settings-sub-menu-svg-css-down");
      accountArrowIcon.classList.add("ds-settings-sub-menu-svg-css-up");
    }

    document.body.style.overflow = "auto";
    window.scrollTo(0, 0);
  }

  const menuDrawer = document.querySelector("." + MENU_DRAWER_CLASS);
  if (menuDrawer) {
    menuDrawer.addEventListener("toggle", (event) => {
      if (event.target.open) {
        restoreNavItem();
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    });
  }

  const menuToggle = document.querySelector(".header__icon--menu");
  if (menuToggle) {
    menuToggle.addEventListener("click", () => {
      setTimeout(restoreNavItem, 0);
    });
  }

  Object.keys(settingsMenuIdMap).forEach((mobileNavId) => {
    const navElement = document.getElementById(mobileNavId);
    if (navElement) {
      navElement.addEventListener("click", switchNavItem);
    }
  });

  Object.keys(accountMenuIdMap).forEach((navId) => {
    const navElement = document.getElementById(navId);
    if (navElement) {
      navElement.addEventListener("click", switchNavItem);
    }
  });

  const settingsButton = document.getElementById(SETTINGS_BUTTON_ID);
  if (settingsButton) {
    settingsButton.addEventListener("click", toggleSettingsMenu);
  }

  const accountButton = document.getElementById(ACCOUNT_BUTTON_ID);
  if (accountButton) {
    accountButton.addEventListener("click", toggleAccountMenu);
  }

  restoreNavItem();
})();
